import { MediaFormat } from '../../../../../types/campaign'
import {
  MEDIA_DURATIONS,
  VOOH_CREATION_DURATIONS,
  VOOH_CREATION_MAX_DURATIONS,
} from '../../../../../constant'
import { SelectOption } from '../../../../../components/Form/Select'
import { TFunction } from 'react-i18next'

export class MediaDurationHelper {
  /**
   * Function which tells what are available durations for given medium format
   *
   * @param mediumFormat
   * @param broadsign - Broadsign campaigns allow every second from 1 to 30
   */
  static get(mediumFormat: MediaFormat, broadsign = false): number[] {
    if (broadsign) {
      return Array.from({ length: 30 }, (_, index) => index + 1)
    }

    const additionalDuration = 5

    // all dgIns have additional duration
    if (mediumFormat.includes('dgIn')) {
      return [additionalDuration, ...MEDIA_DURATIONS]
    }

    // dgCs has also an additional duration
    if (mediumFormat.includes('dgCs')) {
      return [additionalDuration, ...MEDIA_DURATIONS]
    }

    return [...MEDIA_DURATIONS]
  }

  /**
   * Function for getting available campaign creation duration and creation duration periods for vooh
   *
   * @param tFunction
   * @param campaignMaxDuration
   * @param isExternalAgency
   */

  public static getVoohDurationOptions = (
    tFunction: TFunction,
    campaignMaxDuration?: number | null,
    isExternalAgency?: boolean
  ): SelectOption[] => {
    if (isExternalAgency) {
      return VOOH_CREATION_DURATIONS.map(
        (duration: number): SelectOption => ({
          value: duration.toString(),
          label: duration.toString(),
        })
      )
    }

    if (campaignMaxDuration !== undefined) {
      return VOOH_CREATION_DURATIONS.filter(val => {
        const maxDuration =
          campaignMaxDuration || VOOH_CREATION_DURATIONS[VOOH_CREATION_DURATIONS.length - 1]

        return val <= maxDuration
      }).map(
        (duration: number): SelectOption => ({
          value: duration.toString(),
          label: duration.toString(),
        })
      )
    }

    return [...Object.values(VOOH_CREATION_MAX_DURATIONS)].map(
      (duration: number | null): SelectOption => ({
        value: duration ? duration.toString() : '',
        label: duration ? duration.toString() : tFunction('form.campaign.creations.open'),
      })
    )
  }
}
